import './App.css';
import { Routing } from "./appRoutes";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import ConfiguratorViewer from './components/ConfiguratorViewer/ConfiguratorViewer'

function App() {
  return (
    <>
      {/* <ConfiguratorViewer /> */}
      <Routing />
      <ToastContainer position="top-right" autoClose={4000} />
    </>
  );
}

export default App;
